import { useCallback } from 'react';
import type { OnChangeValue } from 'react-select';
import Select from 'react-select';
import type { Workspace } from '@/types';

type WorkspaceInfo = Pick<Workspace, 'id' | 'name'>;

type Props = {
  className?: string;
  options: WorkspaceInfo[];
  onChange: (w: WorkspaceInfo) => unknown;
  value: WorkspaceInfo;
};

export const WorkspaceSelect = ({ className, options, onChange, value }: Props) => {
  const handleChange = useCallback((e: OnChangeValue<WorkspaceInfo, false>) => {
    const option = options.find(f => f.id === e.id);
    onChange(option);
  }, [onChange, options]);

  return (
    <Select
      className={className}
      id="workspace-select"
      name="workspace"
      onChange={handleChange}
      getOptionLabel={(option: WorkspaceInfo) => option.name}
      getOptionValue={(option: WorkspaceInfo) => option.id.toString()}
      options={options}
      value={value} />
  );
};

export default WorkspaceSelect;